function extractDistinctValues(array, property) {
  const uniqueValues = [...new Set(array?.map((item) => item[property]))]
  return uniqueValues.map((value) => ({ text: value, value }))
}

export function getFilteredValues(data, filters, filterKey) {
  if (!data) return []
  return extractDistinctValues(
    data.filter((item) =>
      Object.keys(filters).every((key) =>
        key === filterKey // Skip filtering for the self column
          ? true
          : filters[key]?.length > 0
            ? filters[key].includes(item[key])
            : true
      )
    ),
    filterKey
  )
}
